import { ReactNode, createContext, useState } from 'react';

const defaultAuthContextValue: {
  token: string | null;
  setToken: (value: string | null) => void;
} = {
  token: null,
  setToken: (value: string | null) => {}
};

export const AuthContext = createContext(defaultAuthContextValue);

const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(null);

  return (
    <AuthContext.Provider
      value={{
        token,
        setToken
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
